import React from 'react'
import styles from './UserList.module.css'
import {ImCross} from 'react-icons/im'
import {BiArrowBack} from 'react-icons/bi' 
const Listuser=(props)=>{
    return(
        <div className={styles.listcon}>
      <div className={styles.header}>
          <div className={styles.backbutton}><BiArrowBack  onClick={props.backbuttonhandle}/></div>
            <div className={styles.title}>{props.title}</div>
      </div>
           {props.children}

        </div>

    )
}

export default Listuser